import { render, staticRenderFns } from "./TheConfigGoodsTable.vue?vue&type=template&id=681d205c&"
import script from "./TheConfigGoodsTable.vue?vue&type=script&lang=js&"
export * from "./TheConfigGoodsTable.vue?vue&type=script&lang=js&"
import style0 from "./TheConfigGoodsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports